module.exports = __webpack_public_path__ + "static/media/34.ae7ac622.jpg";